exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".service-terminate .sweet-modal.bounce{-webkit-animation-name:none;animation-name:none}.terminate-2 .sweet-modal.is-alert .sweet-content{padding:44px 24px 32px 24px}", ""]);

// exports
